<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Empresas</h3>
            </div>
            <div class="col-auto">
              <b-button @click="formEmpresa()">Novo</b-button>
            </div>
          </div>
        </div>
        <div class>
          <div class="row">
            <div class="col mb-2">
              <div class="text-right">
                <b-button v-b-toggle.collapse-1 variant="primary">
                  <i class="fa fa-filter"></i>
                  Filtros
                </b-button>
              </div>
              <b-collapse id="collapse-1" class="mt-2">
                <b-card header="Filtros para aplicar">
                  <div class="container">
                    <div class="row">
                      <div class="col-3">
                        <div class="form-group" :class="{'has-danger': errors.has('cnpj')}">
                          <label>CNPJ</label>
                          <input id="cnpj" name="cnpj" ref="cnpj" v-model="filtro.cnpj" type="text" class="form-control"
                            v-mask="'##.###.###/####-##'" v-validate="'cnpj'" />
                          <div
                              v-if="errors.has('cnpj')"
                              class="help-block form-text text-muted form-control-feedback"
                            >{{errors.first('cnpj')}}</div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group">
                          <label for>Nome</label>
                          <input v-model="filtro.nomeEmpresa" type="text" class="form-control" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="form-group">
                          <label for>Status</label>
                          <multiselect
                            v-model="filtro.status"
                            :multiple="true"
                            :taggable="true"
                            :options="optionsStatus"
                            :hide-selected="true"
                            :showLabels="false"
                            :searchable="false"
                            placeholder="Selecione o status da empresa"
                          ></multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="row text-right">
                      <div class="col">
                        <b-link @click="limpar" class="mr-2">Limpar</b-link>
                        <b-button v-b-toggle.collapse-1 @click="find" variant="primary">Aplicar</b-button>
                      </div>
                    </div>
                  </div>
                </b-card>
              </b-collapse>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="element-box">
                <div class="mb-4">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    :current-page="currentPage"
                    align="fill"
                    size="sm"
                    class="my-0"
                  ></b-pagination>
                </div>

                <b-table
                  id="listEmpresa"
                  name="listEmpresa"
                  ref="listEmpresa"
                  striped
                  hover
                  bordered
                  :current-page="currentPage"
                  :per-page="perPage"
                  :items="getEmpresas"
                  :fields="fieldList"
                >
                  <template slot="[status]" slot-scope="row">
                    <b-badge
                      v-if="row.item.status == 'Habilitado'"
                      variant="success"
                    >{{row.item.status}}</b-badge>
                    <b-badge v-else variant="danger">{{row.item.status}}</b-badge>
                  </template>
                  <template slot="[actions]" slot-scope="row">
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      title="Img. Cartão"
                      @click="showImgCartao(row.item)"
                    >
                      <i class="fa fa-credit-card"></i>
                    </b-button>
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      title="Editar Empresa"
                      @click="formEmpresa(row.item._id)"
                    >
                      <i class="fa fa-edit"></i>
                    </b-button>
                    <b-button
                        variant="outline-primary"
                        size="sm"
                        title="Afiliados"
                        @click="formAfiliado(row.item._id)"
                    >
                      <i class="fa fa-handshake"></i>
                    </b-button>
                    <b-button
                        variant="outline-primary"
                        size="sm"
                        title="Termo Adesão"
                        @click="showTermoAdesao(row.item)"
                    >
                      <i class="fa fa-file-invoice"></i>
                    </b-button>
                    <b-button
                      v-if="row.item.status != 'Habilitado'"
                      variant="outline-success"
                      size="sm"
                      title="Ativar Empresa"
                      @click="ativar(row.item)"
                    >
                      <i class="fa fa-check"></i>
                    </b-button>
                    <b-button
                      v-if="row.item.status == 'Habilitado'"
                      title="Desativar"
                      variant="outline-danger"
                      size="sm"
                      @click="desativar(row.item)"
                    >
                      <i class="fa fa-minus"></i>
                    </b-button>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>

        <b-modal id="uploadLogo" title="Imagem do cartão" hide-footer size="lg">
          <form @submit.prevent="uploadLogo" autocomplete="off">
            <div class="container">
              <div class="row">
                <div class="col-md-6">
                  <h6>Frente Cartão</h6>
                  <div class="custom-file">
                    <input
                      type="file"
                      class="custom-file-input"
                      @change="processFile($event)"
                      id="validatedCustomFile"
                      required
                    />
                    <label class="custom-file-label" for="validatedCustomFile">Informe o arquivo...</label>
                  </div>
                  <small
                    id="emailHelp"
                    class="form-text text-muted"
                  >Adicione arquivos com 350px de largura por 203px de altura.</small>
                </div>
                <div class="col-md-6">
                  <h6>Verso Cartão</h6>
                  <div class="custom-file">
                    <input
                      type="file"
                      class="custom-file-input"
                      @change="processFileVerso($event)"
                      id="validatedCustomFile"
                      required
                    />
                    <label class="custom-file-label" for="validatedCustomFile">Informe o arquivo...</label>
                  </div>
                  <small
                    id="emailHelp"
                    class="form-text text-muted"
                  >Adicione arquivos com 350px de largura por 203px de altura.</small>
                </div>
              </div>
              <div class="row">
                <div class="col-6 text-center mt-3">
                  <img
                    v-if="imagePreview"
                    id="imageUploadTmp"
                    alt="image"
                    width="300px"
                    height="200px"
                    :src="imagePreview"
                    class="img-fluid"
                  />
                  <img
                    v-else
                    id="imageFrente"
                    alt="image"
                    width="300px"
                    height="200px"
                    :onerror="`this.onerror=null;this.src='${require('@/assets/images/white.jpg')}'`"
                    :src="urlCartaoFrente"
                    class="img-fluid"
                  />
                </div>
                <div class="col-6 text-center mt-3">
                  <img
                    v-if="imagePreviewVerso"
                    id="imageUploadTmpVerso"
                    alt="image"
                    width="300px"
                    height="200px"
                    :src="imagePreviewVerso"
                    class="img-fluid"
                  />
                  <img
                    v-else
                    id="imageFrente"
                    alt="image"
                    width="300px"
                    height="200px"
                    :onerror="`this.onerror=null;this.src='${require('@/assets/images/white.jpg')}'`"
                    :src="urlCartaoVerso"
                    class="img-fluid"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col text-right mb-2">
                  <div class="btn-login">
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="cancelar"
                    >Cancelar</button>
                    <button type="submit" class="btn btn-primary">Salvar</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <b-modal id="termoAdesao" title="Termo de Adesão" hide-footer size="lg">
          <form @submit.prevent.stop="uploadTermoAdesao" autocomplete="off">
              <div class="container">
                <div class="row">
                  <div class="col">
                    <div class="custom-file">
                      <input
                          type="file"
                          accept="application/pdf"
                          class="custom-file-input"
                          @change="processFileTermoAdesao($event)"
                          id="validatedCustomFileTermoAdesao"
                          required
                      />
                      <label class="custom-file-label" for="validatedCustomFile">Informe o arquivo...</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col text-right mb-2">
                    <div class="btn-login">
                      <button
                          type="button"
                          class="btn btn-outline-secondary"
                          @click="$bvModal.hide('termoAdesao')"
                      >Cancelar</button>
                      <button type="submit" class="btn btn-primary">Salvar</button>
                    </div>
                  </div>
                </div>
              </div>
          </form>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import Multiselect from 'vue-multiselect';
import { Validator } from "vee-validate";
import utils from "@/utils";

export default {
  created() {
    Validator.extend("cnpj", {
      getMessage: () => "CNPJ inválido",
      validate: value => {
        return !!utils.TestaCNPJ(value);
      }
    });
  },
  components:{
    Multiselect
  },
  async mounted() {
    moment.locale("pt-br");
  },
  computed: {
    urlCartaoVerso() {
      if (this.empresa) {
        return `${axios.defaults.baseURL}/api/juridicaImagemCartao/image?idJuridica=${this.empresa._id}&tipo=VERSO&t=${new Date().getTime()}`;
      }
      return "";
    },
    urlCartaoFrente() {
      if (this.empresa) {
        return `${axios.defaults.baseURL}/api/juridicaImagemCartao/image?idJuridica=${this.empresa._id}&tipo=FRENTE&t=${new Date().getTime()}`;
      }
      return "";
    }
  },
  data() {
    return {
      filtro: {},
      optionsStatus: ['Habilitado', 'Desabilitado'],
      empresa: null,
      items: {},
      imagePreview: null,
      imagePreviewVerso: null,
      imgCartao: null,
      imgCartaoVerso: null,
      fileTermoAdesao: null,
      currentPage: 1,
      perPage: 10,
      totalCount: 0,
      fieldList: [
        {
          sortable: true,
          key: "createdAt",
          label: "Data cadastro",
          formatter: value => {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
          }
        },
        {
          sortable: true,
          key: "status"
        },
        {
          sortable: true,
          key: "name",
          label: "Nome"
        },
        {
          sortable: true,
          key: "cnpj",
          label: "CNPJ",
          formatter: value => {
            return value.replace(
              /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
              "$1.$2.$3/$4-$5"
            );
          }
        },
        { key: "actions", label: "Ações", class: "text-center" }
      ]
    };
  },
  methods: {
    getEmpresas(ctx) {
      let params = {};
      if (this.filtro.nomeEmpresa) {
        params['name'] = `${this.filtro.nomeEmpresa}`;
      }
      if (this.filtro.status && this.filtro.status.length > 0) {
        params['status'] = this.filtro.status;
      }
      if (this.filtro.cnpj) {
        params['cnpj'] = this.filtro.cnpj;
      }
      this.currentPage = ctx.currentPage;
      let promise = axios.get(
        `/api/juridica/filter?limit=${this.perPage}&page=${ctx.currentPage}`,
        {
          params
        }
      );

      return promise.then(response => {
        this.totalCount = response.data.totalCount;
        return response.data.data || [];
      });
    },
    planos(empresa) {
      this.$router.push({
        name: "EmpresaPlano",
        query: { empresa: empresa._id }
      });
    },
    formEmpresa(id) {
      this.$router.push({ name: "EmpresaForm", query: { id } });
    },
    formAfiliado(id) {
      this.$router.push({ name: "Afiliado", query: { empresa: id } });
    },
    async ativar(empresa) {
      try {
        empresa.status = "Habilitado";
        delete empresa.__v;
        delete empresa.updatedAt;
        delete empresa.createdAt;
        await axios.put(`/api/juridica/${empresa._id}`, empresa);
        this.$refs.listEmpresa.refresh();
      } catch (error) {
        // eslint-disable-next-line
        console(error);
      }
    },
    async desativar(empresa) {
      try {
        empresa.status = "Desabilitado";
        delete empresa.__v;
        delete empresa.updatedAt;
        delete empresa.createdAt;
        await axios.put(`/api/juridica/${empresa._id}`, empresa);
        this.$refs.listEmpresa.refresh();
      } catch (error) {
        // eslint-disable-next-line
        console(error);
      }
    },
    showTermoAdesao(empresa) {
      this.empresa = empresa;
      this.$bvModal.show('termoAdesao');
    },
    showImgCartao(empresa) {
      this.empresa = empresa;
      this.$bvModal.show("uploadLogo");
    },
    processFile(event) {
      this.imgCartao = event.target.files[0];
      if (this.imgCartao) {
        let file = new FileReader();
        const _self = this;
        file.onload = e => {
          _self.imagePreview = e.target.result;
        };
        file.readAsDataURL(this.imgCartao);
      }
    },
    processFileTermoAdesao(event) {
      this.fileTermoAdesao = event.target.files[0];
    },
    processFileVerso(event) {
      this.imgCartaoVerso = event.target.files[0];
      if (this.imgCartaoVerso) {
        let file = new FileReader();
        const _self = this;
        file.onload = e => {
          _self.imagePreviewVerso = e.target.result;
        };
        file.readAsDataURL(this.imgCartaoVerso);
      }
    },
    async uploadTermoAdesao() {
      try {
        const payload = new FormData();
        payload.append("file", this.fileTermoAdesao);
        payload.append("idJuridica", this.empresa._id);
        await axios.post("/api/termoAdesao/upload/", payload);
        this.$bvModal.hide("termoAdesao");
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }
    },
    async uploadLogo() {
      try {
        const payload = new FormData();
        payload.append("file", this.imgCartao);
        payload.append("fileVerso", this.imgCartaoVerso);
        payload.append("idJuridica", this.empresa._id);
        await axios.post("/api/juridicaImagemCartao/upload/", payload);
        this.$bvModal.hide("uploadLogo");
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }
    },
    formVendedores(empresa) {
      this.$router.push({
        name: "EmpresaVendedor",
        query: { empresa: empresa._id }
      });
    },
    cancelar() {
      this.imagePreview = null;
      this.imagePreviewVerso = null;
      this.imgCartao = null;
      this.imgCartaoVerso = null;

      this.$bvModal.hide("uploadLogo");
    },
    limpar() {
      this.filtro = {};
    },
    find() {
      this.$root.$emit('bv::refresh::table', 'listEmpresa')
    }
  }
};
</script>
